import { WeatherSource } from '@ebalance/proto/bffuser/v1/weather_forecast_model_pb'

/**
 * 気象予報の取得元 (`ForecastWeatherBar.weatherSource`) が、日別 1 値の源
 * (府県・週間) か (AC-WD-007a)。
 *
 * 府県・週間は日別粒度の予報で、backend は日別 1 値を hourlyWeather の 1 件
 * (hour=0) として返す (3 時間ブロックへ複製しない)。VPFD (3 時間予報) は実際の
 * 時間帯別で、正時の点が無いブロックは hourlyWeather に含まれない。UNSPECIFIED
 * (取得元を記録する前の確定済み snapshot など) と UNAVAILABLE (どの源にも行が
 * 無い) は日別扱いにしない。
 */
export function isDailyWeatherSource(
  source: WeatherSource | undefined,
): boolean {
  return source === WeatherSource.PREFECTURAL || source === WeatherSource.WEEKLY
}

/**
 * 翌日断面の「05 時前」案内 (AC-WD-005e) を出すか。
 *
 * 「発表前」は時計 (JST 05:00) ではなく、表示中の予報が日別の源 (VPFD の行が
 * 無い状態: 取込遅延・取得失敗を含む) であることで判定する。天気の日別表示と
 * 案内が必ず一致する。
 *
 * BG_TOTAL 業務確定済みの断面は出さない: 確定済み表示は確定時点の予報の値・
 * 粒度のままで、「発表後の表示となります」と書くと事実に反する (AC-DFC-014)。
 * 確定済みの判定は backend が確定時 snapshot を返す条件と同じ
 * `WorkflowCase.demandStepConfirmed` を使う。参照表示 (readonly) だけでは消さない。
 */
export function shouldShowBeforeVpfdDailyNotice(args: {
  isTargetDateTomorrow: boolean
  weatherSource: WeatherSource | undefined
  isBgTotalConfirmed: boolean
}): boolean {
  return (
    args.isTargetDateTomorrow &&
    isDailyWeatherSource(args.weatherSource) &&
    !args.isBgTotalConfirmed
  )
}
